import {cl} from '../../common/functions';

const inputNumberValue = () => {
  const inputNumberWrapper = document.querySelectorAll('body.woocommerce div.quantity');
  // prettier-ignore
  !!inputNumberWrapper.length && [...inputNumberWrapper].forEach(wrapper => {
    const inputNumber = wrapper.querySelector(`input[type="number"][name="quantity"]`);
    if (!!inputNumber) {
      const max = inputNumber.getAttribute("max");
      const min = inputNumber.getAttribute("min");
      const step = inputNumber.getAttribute("step");

      // insert des élements custom html
      const html = /*html*/ `
      <div class="quantity-nav">
        <button class="quantity-button quantity-up">+</button>
        <button class="quantity-button quantity-down">-</button>
      </div>`;
      inputNumber.insertAdjacentHTML('afterend', html);

      // gestion des events + ou -
      const quantityUp = wrapper.querySelector("button.quantity-up");
      // prettier-ignore
      !!quantityUp && quantityUp.addEventListener('click', (e) => {
        e.preventDefault();

        const oldInputValue = Number(inputNumber.value);
        let newInputValue = 0;

        if (!!max) {
          if (oldInputValue >= max) {
            newInputValue = oldInputValue;
          } else {
            if (!!step) {
              newInputValue = oldInputValue + Number(step);
            } else {
              newInputValue = oldInputValue + 1;
            }
          }
        } else {
          if (!!step) {
            newInputValue = oldInputValue + Number(step);
          } else {
            newInputValue = oldInputValue + 1;
          }
        }

        inputNumber.value = newInputValue;
      });

      const quantityDown = wrapper.querySelector("button.quantity-down");
      // prettier-ignore
      !!quantityDown && quantityDown.addEventListener('click', (e) => {
        e.preventDefault();

        const oldInputValue = Number(inputNumber.value);
        let newInputValue = 0;

        if (!!min) {
          if (oldInputValue <= min) {
            newInputValue = oldInputValue;
          } else {
            if (!!step) {
              newInputValue = oldInputValue - Number(step);
            } else {
              newInputValue = oldInputValue - 1;
            }
          }
        } else {
          if (!!step) {
            newInputValue = oldInputValue - Number(step);
          } else {
            newInputValue = oldInputValue - 1;
          }
        }

        inputNumber.value = newInputValue;
      });
    }
  });
};

export {inputNumberValue};
